var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"filter-link",attrs:{"to":{ name: _vm.linkName, params: _vm.linkParams }}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }